module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-layout', {
    staticClass: "elevation-1 box-card",
    attrs: {
      "row": "",
      "wrap": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "box-title",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Destaques")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "grow": "",
      "slider-color": "red"
    }
  }, [_vm._l((_vm.tabsDestaquesNotificacao), function(tab) {
    return _c('v-tab', {
      key: tab.url,
      attrs: {
        "href": '#' + tab.url,
        "ripple": false
      },
      on: {
        "click": function($event) {
          tab.notificacao !== undefined ? _vm.apagaNotificacao(tab.url) : null
        }
      }
    }, [(tab.notificacao !== undefined) ? _c('v-badge', {
      attrs: {
        "right": "",
        "ml-2": "",
        "color": "notificacao-red"
      }
    }, [_c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(tab.notificacao))]), _vm._v("\n              " + _vm._s(tab.nome) + "\n          ")]) : [_vm._v("\n            " + _vm._s(tab.nome) + "\n          ")]], 2)
  }), _vm._v(" "), _vm._l((_vm.tabsDestaquesNotificacao), function(tab) {
    return _c('v-tab-item', {
      key: tab.url,
      staticClass: "no-bar",
      staticStyle: {
        "height": "405px",
        "overflow-y": "scroll"
      },
      attrs: {
        "id": tab.url
      }
    }, [(tab.url === 'Pedidos/Novos') ? _c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [(_vm.orders.length > 0) ? _c('v-card-text', _vm._l((_vm.orders), function(order) {
      return _c('order', {
        key: order.id,
        attrs: {
          "value": order
        },
        on: {
          "details": function($event) {
            return _vm.details($event)
          }
        }
      })
    }), 1) : _c('v-card-text', {
      staticClass: "nothing-new"
    }, [_vm._v("\n                Nenhum pedido foi localizado\n              ")])], 1) : _c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [(_vm.estimations.length > 0) ? _c('v-card-text', _vm._l((_vm.estimations), function(estimation) {
      return _c('order', {
        key: estimation.id,
        attrs: {
          "value": estimation
        },
        on: {
          "details": function($event) {
            return _vm.details($event)
          }
        }
      })
    }), 1) : _c('v-card-text', {
      staticClass: "nothing-new"
    }, [_vm._v("\n                Nenhum orçamento foi localizado\n              ")])], 1)], 1)
  })], 2)], 1), _vm._v(" "), (_vm.loadingFeatured) ? _c('v-progress-linear', {
    staticClass: "loading-box",
    attrs: {
      "height": "2",
      "color": "red",
      "indeterminate": true
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c9ff62a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/inicio/featured.vue
// module id = 752
// module chunks = 3